import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";

const AUTH_API = '/api/auth/';
const httpOptions = {
  headers: new HttpHeaders({'Content-Type' : 'application/json'})
};

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient) {}

  login(url, credentials): Observable<any> {
    return this.http.post(url + AUTH_API + 'signin', {
      email: credentials.email,
      password: credentials.password
    }, httpOptions);
  }
  register(url, user): Observable<any> {
    return this.http.post(url + AUTH_API + 'signup', {
      username: user.username,
      email: user.email,
      password: user.password
    }, httpOptions);
  }

  googleLogin(url: string, credentials: any): Observable<any> {
    console.log('google login called', url);
    return this.http.post(url + '/api/auth/google', credentials, httpOptions);
  }
}
